module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-friend-2-medium-02b1decba259ecfbbaa2bce1d28f4919.jpg";